import { render } from "./Payments.vue?vue&type=template&id=25678e48&scoped=true&ts=true"
import script from "./Payments.vue?vue&type=script&lang=ts"
export * from "./Payments.vue?vue&type=script&lang=ts"

import "./Payments.vue?vue&type=style&index=0&id=25678e48&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25678e48"]])

export default __exports__